import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./TopSec.module.css";
import mountain from "../assets/webp/mountain.webp";
import mobilemountain from "../assets/webp/Asset 27@2x.png";

import tree from "../assets/SVG/Asset 23@2x.png";
import treemobile from "../assets/SVG/Asset 31@2x.png";


import interactives from "../assets/SVG/Website UI-03.png";
import interactivesmobile from "../assets/SVG/Home Page Phone-02.png";

import jingles from "../assets/SVG/Website UI-02.png";
import jinglesmobile from "../assets/SVG/Home Page Phone-03.png";

import stories from "../assets/SVG/Website UI-04.png";
import storiesmobile from "../assets/SVG/Home Page Phone-04.png";



import treebottomgrass from "../assets/webp/treebottomgrass.webp";
import boat from "../assets/SVG/boat.svg"
import wood from "../assets/webp/throne.webp"
import tiger from "../assets/webp/lion.webp"
import lionboard from '../assets/Characterpopup/Asset 127@2x.png'
import Elphe from "../assets/webp/elephant.webp"
import elphepaw from "../assets/webp/elepaw.webp"
import elephantbaord from '../assets/Characterpopup/Asset 103@2x.png'
import tigerpaw from "../assets/webp/lionpaw.webp"
import table from "../assets/webp/table.webp"
import river from "../assets/webp/updatedriver1.png"
import flowers from "../assets/webp/flower.webp"
import board from "../assets/webp/board.webp"
import boardmobile from "../assets/webp/Asset 26@2x.png"

import cave from "../assets/webp/cave1.webp"
import aboutUs from "../assets/webp/aboutUs.webp";
import patchright from "../assets/webp/patch_right.webp";
import patchleft from "../assets/webp/patch_left.webp";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
// import Footer from "./Footer";
import { Helmet } from "react-helmet-async";
import footerimg from "../assets/webp/footer2.webp";

export default function TopSec() {
  const characterData = {
    lion: {
      title: "Hello! I am Liona",
      description: [
        "I am leader",
        "I am decisive",
        "I am a confident"
      ],
      className: "lionaText",
      imageWidth: "600px",
      imageHeight: "auto",
      mobileImageWidth: "350px",
      mobileImageHeight: "auto"
    },
    elephant: {
      title: "Hello! I am Elephiphi",
      description: [
        "I am kind",
        "I am loving",
        "I am motherly"
      ],
      className: "elephiphiText",
      imageWidth: "700px",
      imageHeight: "auto",
      mobileImageWidth: "400px",
      mobileImageHeight: "auto"
    }
  };
  const [lionOpen, setLionOpen] = useState(false);
  const [eleOpen, setEleOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Check if mobile device
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const openLion = () => { setEleOpen(false); setLionOpen(true); };
  const closeLion = () => setLionOpen(false);
  const openEle = () => { setLionOpen(false); setEleOpen(true); };
  const closeEle = () => setEleOpen(false);

  // ESC key handler for either modal
  useEffect(() => {
    if (!lionOpen && !eleOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') {
        closeLion();
        closeEle();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lionOpen, eleOpen]);


  

  // Get current character data
  const currentCharacter = lionOpen ? characterData.lion : eleOpen ? characterData.elephant : null;
  const currentImage = lionOpen ? lionboard : eleOpen ? elephantbaord : null; 
  return (
    <>
     <Helmet>
  <title>
    Jungle Morals - Kids Moral Stories, Songs & Learning Videos
  </title>

  <meta
    name="description"
    content="Fun moral stories, songs, and interactive learning videos for kids aged 4-8. Jungle Morals helps children build kindness, confidence, empathy, and positive values through joyful learning."
  />

  <meta name="robots" content="index, follow" />

  <link
    rel="canonical"
    href="https://www.junglemorals.com/"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Jungle Morals - Kids Moral Stories, Songs & Learning Videos"
  />

  <meta
    property="og:description"
    content="Fun moral stories, songs, and interactive learning videos for kids aged 4-8."
  />

  <meta
    property="og:url"
    content="https://www.junglemorals.com/"
  />

  <meta property="og:type" content="website" />

  <meta
    property="og:image"
    content="https://www.junglemorals.com/static/media/home-banner.webp"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Jungle Morals - Kids Moral Stories, Songs & Learning Videos"
  />

  <meta
    name="twitter:description"
    content="Fun moral stories, songs, and interactive learning videos for kids aged 4-8."
  />

  <meta
    name="twitter:image"
    content="https://www.junglemorals.com/static/media/home-banner.webp"
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.junglemorals.com/#organization",
          name: "Jungle Morals",
          url: "https://www.junglemorals.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/logo.webp"
          },
          description:
            "Jungle Morals creates educational stories, songs, and videos that help children develop empathy, confidence, kindness, and positive values."
        },
        {
          "@type": "WebSite",
          "@id": "https://www.junglemorals.com/#website",
          url: "https://www.junglemorals.com/",
          name: "Jungle Morals",
          publisher: {
            "@id": "https://www.junglemorals.com/#organization"
          }
        },
        {
          "@type": "WebPage",
          "@id": "https://www.junglemorals.com/#webpage",
          url: "https://www.junglemorals.com/",
          name: "Jungle Morals - Kids Moral Stories, Songs & Learning Videos",
          description:
            "Fun moral stories, songs, and interactive learning videos for kids aged 4-8.",
          inLanguage: "en",
          isPartOf: {
            "@id": "https://www.junglemorals.com/#website"
          },
          about: {
            "@id": "https://www.junglemorals.com/#organization"
          },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/home-banner.webp"
          }
        },
        {
          "@type": "VideoObject",
          "@id": "https://www.junglemorals.com/#featured-video",
          name: "Jungle Morals Kids Learning Video",
          description:
            "Educational moral stories and songs for children.",
          thumbnailUrl:
            "https://i.ytimg.com/vi/dH6lDGgTN4I/hqdefault.jpg",
          embedUrl:
            "https://www.youtube.com/embed/dH6lDGgTN4I",
          contentUrl:
            "https://www.youtube.com/watch?v=dH6lDGgTN4I",
          publisher: {
            "@id": "https://www.junglemorals.com/#organization"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.junglemorals.com/#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://www.junglemorals.com/"
            }
          ]
        }
      ]
    })}
  </script>
</Helmet>
      <div className={styles.topSection}>
        <div className={styles.treeContainer}>
          <img src={tree} alt="Tree" className={styles.tree} />
          <img src={treemobile} alt="Tree" className={styles.treemobile} />

          <div className={styles.treeLinks}>
            <h3 className={`font-adventuring ${styles.ourlinks}`}>Watch Our</h3>

            <a href="https://www.youtube.com/watch?v=konV2GSts7Q" target="_blank" rel="noopener noreferrer" className={styles.jingles}>
              <img src={jingles} alt="" />
              <img src={jinglesmobile} alt="" srcset="" className={styles.jinglesmobile} />
              <h3 className="font-adventuring">Jingles</h3>
            </a>
            <a href="https://www.youtube.com/watch?v=dH6lDGgTN4I" target="_blank" rel="noopener noreferrer" style={{ fontSize: '2rem' }} className={styles.interactive}>
              <img src={interactives} alt="" />
              <img src={interactivesmobile} alt="" srcset="" className={styles.interactivesmobile} />
              <h3 className="font-adventuring">Interactives</h3>
            </a>
            <a href="https://www.youtube.com/watch?v=jc0A01yUI_w" target="_blank" rel="noopener noreferrer" className={styles.stories}>
              <img src={stories} alt="" />
              <img src={storiesmobile} alt="" srcset="" className={styles.storiesmobile} />
              <h3 className="font-adventuring">Stories</h3>
            </a>
          </div>
          <img src={treebottomgrass} alt="treebottomgrass" className={styles.treebottomgrass} />
        </div>

        <div className={styles.mountainContainer}>
          <img src={mountain} alt="Mountain" className={styles.mountain} />
          <img src={mobilemountain} alt="Mountain" className={styles.mountainmob} />

          <div className={styles.boardContainer}>
            <img src={board} alt="board" className={styles.board} />
            <img src={boardmobile} alt="board" className={styles.boardmobile} />

            <div className={styles.boardText}>
              <h1 className="font-adventuring">For Kids' Joy <br /> and Parents'<br /> Peace of Mind</h1>
            </div>
          </div>
        </div>
        <div className={`${styles.grassContainer} container-fluid `}>
          <div className={styles.riverContainer}>
            <img src={river} alt="River" className={styles.river} />
            <div className={styles.boatWrapper} onClick={() => navigate('/characters')}>
              <img src={boat} alt="Boat" className={styles.boat} onClick={() => navigate('/characters')} />

              {/* <button className={`font-adventuring ${styles.boatBtn}`} onClick={() => navigate('/characters')}>
                Click Me
              </button> */}

              <Link
                to="/characters"
                className={`font-adventuring  text-decoration-none  ${styles.boatBtn}`}
              >
                Click Me
              </Link>

            </div>
          </div>
          <div className={styles.flowerCaveSection}>
            <img src={flowers} alt="flower" className={styles.flowers} />
            <img src={patchleft} alt="patch" className={styles.patchleft} />
            <img src={patchright} alt="patch" className={styles.patchright} />

            <div className={styles.caveContainer}>
              <img src={cave} alt="cave" className={styles.cave} />
              <div className={styles.caveText}>
                <svg
                  viewBox="0 0 1000 300"
                  preserveAspectRatio="xMidYMid meet"
                  className={styles.caveSvg}
                >

                  <defs>
                    <path id="curve1" d="M 50 350 Q 500 -100 950 350" />
                  </defs>
                  <text className={`font-adventuring ${styles.para1SVG}`}>
                    <textPath href="#curve2" startOffset="50%" textAnchor="middle">
                      Say Hi to our Cuties
                    </textPath>
                  </text>
                </svg>

              </div>
              <div className={styles.caveText2}>
                <svg viewBox="0 0 1000 300"
                  preserveAspectRatio="xMidYMid meet"
                  className={styles.caveSvg}>
                  <defs>
                    <path id="curve2" d="M 70 420 Q 500 -165 950 400" />
                  </defs>
                  <text className={`font-adventuring ${styles.para2SVG}`}>
                    <textPath href="#curve2" startOffset="50%" text-anchor="middle">
                      Click The Paws!
                    </textPath>
                  </text>
                </svg>
              </div>
            </div>
          </div>
          <div className={styles.charactersContainer}>
            <div className={styles.leftGroup}>
              <img src={wood} alt="wood" className={styles.wood} />
              <img src={tiger} alt="Friendly cartoon lion king holding a staff" className={styles.tiger} />
              <img
                src={tigerpaw}
                alt="tiger paw"
                className={styles.tigerPaw}
                role="button"
                tabIndex={0}
                onClick={openLion}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openLion() }}
              />
            </div>

            <div className={styles.rightGroup}>
              <img src={table} alt="table" className={styles.table} />
              <img src={Elphe} alt="Cartoon elephant in a floral dress and flower crown" className={styles.elphe} />
              <img
                src={elphepaw}
                alt="elephant paw"
                className={styles.elphepaw}
                role="button"
                tabIndex={0}
                onClick={openEle}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openEle() }}
              />
            </div>
          </div>
        </div>
        <div className={styles.aboutUsSection}>
          <div className={styles.aboutUsImageWrapper}>
            <img src={aboutUs} alt="aboutusimage" className={styles.aboutUsImage} />

            <div className={styles.aboutUsContent}>
              <h2 className="font-adventuring">About Us</h2>
              <h3 className="font-brandon">
                To inspire growing young minds through engaging, <br />
                value-driven content that nurture empathy, <br />
                curiosity, and positive character traits — building <br />
                a generation of kind,  confident, and socially <br />
                responsible individuals.
                {/* <button
                  className={`font-brandon ${styles.readMoreBtn}`}
                  onClick={() => navigate('/about')}
                  aria-label="Read more about us"
                >
                  Read More..
                </button> */}
              

                <Link
                  to="/about"
                  className={`font-brandon text-decoration-none ${styles.readMoreBtn}`}
                  aria-label="Read more about us"
                >
                  Read More..
                </Link>

              </h3>

            </div>
            <img src={footerimg} alt="footerimg" className={styles.footerimg} />


          </div>

        </div>
        {(lionOpen || eleOpen) && (
          <>
            <div className={styles.backdropLayer} />
            <div className={styles.centerModal} role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
              {/* <button
                className={styles.closeButton}
               onClick={() => { closeLion(); closeEle(); }}
                aria-label="Close modal"
              >
                ×
              </button> */}

              <button
                className={styles.closeButton}
                onClick={() => { closeLion(); closeEle(); }}
                aria-label="Close modal"
              >
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              <div className={styles.modalContent}>
                {currentImage && currentCharacter && (
                  <>
                    <img
                      src={currentImage}
                      alt="Character intro"
                      className={styles.centerImg}
                      style={{
                        width: isMobile ? currentCharacter.mobileImageWidth : currentCharacter.imageWidth,
                        height: isMobile ? currentCharacter.mobileImageHeight : currentCharacter.imageHeight,
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                      }}
                    />
                    <div className={`${styles.modalTextOverlay} ${styles[currentCharacter.className]}`}>
                      <h2 className="font-adventuring">{currentCharacter.title}</h2>
                      <div className="font-adventuring">
                        {Array.isArray(currentCharacter.description) ? (
                          currentCharacter.description.map((line, idx) => (
                            <p key={idx}>{line}</p>
                          ))
                        ) : (
                          <p>{currentCharacter.description}</p>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      {/* <Footer /> */}
    </>
  )
}